import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\"><path d=\"M536.380952 193.584762l318.415238 318.268952L536.380952 830.415238l-51.712-51.687619 266.727619-266.873905-266.727619-266.581333L536.380952 193.584762z m-268.190476 0l318.415238 318.268952L268.190476 830.415238 216.502857 778.727619l266.727619-266.873905L216.454095 245.272381 268.190476 193.584762z\" p-id=\"2259\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol